import { fetchApi } from "../../tools";

const getDataNotas = async (url, headers, carnet, unidad = '', idSede, idSeccion, ciclo) => {
    const resSol = await fetchApi({
      url: url + "/reportes/notas_alumnos",
      headers: headers,
      content: {
        "Carnet"  : carnet,
        "IdCiclo" : ciclo,
        "IdSede" : idSede,
        "Semestre" : 0,
        "Opcion" : "notacarnet",
        "IdSeccion" : idSeccion,
      },
    });
    return resSol?.msg || { msg: [] };
  }

  export { getDataNotas }